import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-responsive-dialog',
  templateUrl: './responsive-dialog.component.html',
  styleUrls: ['./responsive-dialog.component.scss']
})
export class ResponsiveDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
